var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-breadcrumb',{attrs:{"menu":[{label: '客户合同'}, {label: '合同详情'}]}}),_vm._v(" "),_c('contract-detail-component',{attrs:{"contractDetail":_vm.contractDetail}}),_vm._v(" "),_c('button-back')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fcaa2eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/lender/ServiceAdmin/ContractDetail.vue
// module id = null
// module chunks = 